// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HomeThreeAudience — one platform, three audiences
   Prefix: impac_audience_pg_ · no :root variables · no green
   ============================================================ */

.impac_audience_pg_section {
  position: relative;
  width: 100%;
  padding: 48px 16px 60px;
  background: linear-gradient(180deg, #f7eefa 0%, #f1e8fb 100%);
  font-family: "Sora", "Manrope", sans-serif;
  overflow: hidden;
  isolation: isolate;
}

.impac_audience_pg_section *,
.impac_audience_pg_section *::before,
.impac_audience_pg_section *::after {
  box-sizing: border-box;
}

/* soft glows + faint dot grid behind everything */
.impac_audience_pg_section::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 120px;
  right: -180px;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(106, 70, 240, 0.28) 0%, rgba(106, 70, 240, 0) 70%);
  pointer-events: none;
}

.impac_audience_pg_section::after {
  content: "";
  position: absolute;
  z-index: -1;
  inset: 0;
  background-image:
    radial-gradient(circle at 8% 88%, rgba(224, 168, 61, 0.2) 0%, rgba(224, 168, 61, 0) 32%),
    radial-gradient(circle, rgba(38, 16, 138, 0.1) 1.2px, transparent 1.4px);
  background-size: auto, 32px 32px;
  mask-image: linear-gradient(180deg, transparent 0%, #000 30%, #000 80%, transparent 100%);
  pointer-events: none;
}

.impac_audience_pg_container {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* ---------- Title ---------- */

.impac_audience_pg_title {
  max-width: 820px;
  margin: 0;
  font-size: clamp(24px, 4.4vw, 48px);
  font-weight: 800;
  line-height: 1.22;
  letter-spacing: -0.02em;
  color: #0f0f23;
  text-wrap: balance;
}

.impac_audience_pg_brand {
  background: linear-gradient(90deg, #3b1f8f 0%, #7a4cf0 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #3b1f8f;
}

.impac_audience_pg_underline {
  display: block;
  width: 88px;
  height: 4px;
  margin: 18px 0 40px;
  border-radius: 4px;
  background: linear-gradient(90deg, #5b2fd0 0%, #e0a83d 100%);
  transform-origin: left center;
}

/* ---------- Map (mobile: single column) ---------- */

.impac_audience_pg_map {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

/* ---------- Hub ---------- */

.impac_audience_pg_hub_wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 26px;
}

.impac_audience_pg_ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 1px solid rgba(91, 80, 199, 0.28);
  pointer-events: none;
}

.impac_audience_pg_ring_two {
  inset: -18px;
  border-color: rgba(91, 80, 199, 0.14);
}

.impac_audience_pg_hub {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 210px;
  height: 210px;
  padding: 16px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 22%, #5236d6 0%, #26108a 55%, #170a5e 100%);
  box-shadow:
    0 30px 60px rgba(38, 16, 138, 0.38),
    inset 0 0 0 1px rgba(255, 255, 255, 0.14);
  color: #ffffff;
  text-align: center;
}

.impac_audience_pg_hub::before {
  content: "";
  position: absolute;
  inset: 10px;
  border-radius: 50%;
  border: 1px dashed rgba(255, 255, 255, 0.28);
  pointer-events: none;
}

.impac_audience_pg_hub_label {
  padding: 3px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0.16em;
  color: #ffd98a;
}

.impac_audience_pg_logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 8px 0;
  line-height: 1.1;
}

.impac_audience_pg_logo_name {
  margin-top: 4px;
  font-size: 19px;
  font-weight: 800;
  color: #ffffff;
}

.impac_audience_pg_logo_tag {
  margin-top: 2px;
  font-size: 9px;
  font-weight: 500;
  color: #d4cffa;
}

.impac_audience_pg_hub_text {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.45;
  color: #bfd6f5;
}

/* ---------- Connectors ---------- */

.impac_audience_pg_arrow {
  position: relative;
  display: none;
}

.impac_audience_pg_arrow_down {
  display: block;
  width: 2px;
  height: 34px;
  margin: 0 0 6px;
  background: linear-gradient(180deg, rgba(91, 80, 199, 0.15) 0%, #5b50c7 100%);
  transform-origin: top center;
}

.impac_audience_pg_arrow_down::after {
  content: "";
  position: absolute;
  left: -4px;
  bottom: -3px;
  border-top: 9px solid #5b50c7;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

/* ---------- Cards ---------- */

.impac_audience_pg_card {
  position: relative;
  width: 100%;
  max-width: 440px;
  margin-top: 16px;
  padding: 20px 20px 22px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  background: linear-gradient(160deg, rgba(255, 255, 255, 0.82) 0%, rgba(255, 255, 255, 0.5) 100%);
  backdrop-filter: blur(14px);
  box-shadow:
    0 18px 40px rgba(38, 16, 138, 0.1),
    0 2px 6px rgba(38, 16, 138, 0.05);
  overflow: hidden;
  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.4s ease, border-color 0.4s ease;
}

/* gradient accent line that draws across the top on hover */
.impac_audience_pg_card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #5b2fd0 0%, #e0a83d 100%);
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.impac_audience_pg_card_head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.impac_audience_pg_card_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 13px;
  background: linear-gradient(135deg, #ece2ff 0%, #d9ccf8 100%);
  color: #2a1a8a;
  box-shadow: inset 0 0 0 1px rgba(91, 80, 199, 0.18);
  transition: transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1), background 0.3s ease, color 0.3s ease;
}

.impac_audience_pg_card_title {
  margin: 0;
  font-size: 19px;
  font-weight: 800;
  line-height: 1.25;
  color: #0f0f23;
}

.impac_audience_pg_card_desc {
  margin: 14px 0 16px;
  font-size: 13.5px;
  line-height: 1.6;
  font-weight: 500;
  color: #34405e;
}

.impac_audience_pg_card_outcome {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
}

.impac_audience_pg_chip {
  padding: 5px 12px;
  border-radius: 999px;
  background: #ece2ff;
  font-size: 12.5px;
  font-weight: 700;
  color: #26108a;
}

.impac_audience_pg_chip_to {
  background: linear-gradient(100deg, #26108a 0%, #5236d6 100%);
  color: #ffffff;
  box-shadow: 0 8px 16px rgba(38, 16, 138, 0.25);
}

.impac_audience_pg_card_arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e0a83d;
  font-size: 13px;
  font-weight: 800;
  line-height: 1;
  color: #ffffff;
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@media (hover: hover) {
  .impac_audience_pg_card:hover {
    transform: translateY(-8px);
    border-color: #ffffff;
    box-shadow:
      0 30px 56px rgba(38, 16, 138, 0.2),
      0 2px 6px rgba(38, 16, 138, 0.06);
  }

  .impac_audience_pg_card:hover::before {
    transform: scaleX(1);
  }

  .impac_audience_pg_card:hover .impac_audience_pg_card_icon {
    transform: scale(1.1) rotate(-6deg);
    background: linear-gradient(135deg, #26108a 0%, #5236d6 100%);
    color: #ffffff;
  }

  .impac_audience_pg_card:hover .impac_audience_pg_card_arrow {
    transform: translateX(5px);
  }
}

/* ============================================================
   Entrance — fade up, triggered when the section scrolls into view
   (applies at every screen size)
   ============================================================ */

.impac_audience_pg_title,
.impac_audience_pg_underline,
.impac_audience_pg_hub_wrap,
.impac_audience_pg_arrow,
.impac_audience_pg_card {
  opacity: 0;
}

.impac_audience_pg_visible .impac_audience_pg_title {
  animation: impac_audience_pg_fade_up 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.1s forwards;
}

.impac_audience_pg_visible .impac_audience_pg_underline {
  animation: impac_audience_pg_draw_x 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.35s forwards;
}

.impac_audience_pg_visible .impac_audience_pg_hub_wrap {
  animation: impac_audience_pg_zoom_in 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.45s forwards;
}

.impac_audience_pg_visible .impac_audience_pg_ring_one {
  animation: impac_audience_pg_ring_out 1.1s ease-out 0.8s both;
}

.impac_audience_pg_visible .impac_audience_pg_ring_two {
  animation: impac_audience_pg_ring_out 1.3s ease-out 1s both;
}

.impac_audience_pg_visible .impac_audience_pg_hub {
  animation: impac_audience_pg_glow 4s ease-in-out 1.8s infinite;
}

.impac_audience_pg_visible .impac_audience_pg_arrow_down {
  animation: impac_audience_pg_draw_y 0.6s ease-out 0.95s forwards;
}

.impac_audience_pg_visible .impac_audience_pg_arrow_left {
  animation: impac_audience_pg_draw_left 0.7s ease-out 0.95s forwards;
}

.impac_audience_pg_visible .impac_audience_pg_arrow_right {
  animation: impac_audience_pg_draw_right 0.7s ease-out 0.95s forwards;
}

.impac_audience_pg_visible .impac_audience_pg_card_students {
  animation: impac_audience_pg_fade_up 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.1s forwards;
}

.impac_audience_pg_visible .impac_audience_pg_card_professionals {
  animation: impac_audience_pg_fade_up 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.3s forwards;
}

.impac_audience_pg_visible .impac_audience_pg_card_business {
  animation: impac_audience_pg_fade_up 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.5s forwards;
}

/* ============================================================
   Small phones (≤ 360px)
   ============================================================ */

@media (max-width: 360px) {
  .impac_audience_pg_section {
    padding: 40px 12px 50px;
  }

  .impac_audience_pg_hub {
    width: 190px;
    height: 190px;
  }

  .impac_audience_pg_hub_wrap {
    padding: 22px;
  }

  .impac_audience_pg_card {
    padding: 18px 16px 20px;
  }

  .impac_audience_pg_card_title {
    font-size: 17px;
  }

  .impac_audience_pg_card_desc {
    font-size: 13px;
  }
}

/* ============================================================
   Tablet (≥ 768px): two cards side by side, third centred
   ============================================================ */

@media (min-width: 768px) {
  .impac_audience_pg_section {
    padding: 72px 32px 84px;
  }

  .impac_audience_pg_underline {
    margin: 20px 0 52px;
  }

  .impac_audience_pg_map {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-areas:
      "hub hub"
      "ard ard"
      "stu pro"
      "biz biz";
    column-gap: 22px;
    justify-items: stretch;
  }

  .impac_audience_pg_hub_wrap {
    grid-area: hub;
    justify-self: center;
    padding: 30px;
  }

  .impac_audience_pg_hub {
    width: 230px;
    height: 230px;
  }

  .impac_audience_pg_arrow_down {
    grid-area: ard;
    justify-self: center;
    height: 44px;
    margin-bottom: 8px;
  }

  .impac_audience_pg_card {
    max-width: none;
    margin-top: 18px;
    padding: 24px 24px 26px;
  }

  .impac_audience_pg_card_students {
    grid-area: stu;
  }

  .impac_audience_pg_card_professionals {
    grid-area: pro;
  }

  .impac_audience_pg_card_business {
    grid-area: biz;
    justify-self: center;
    width: calc(50% - 11px);
  }

  .impac_audience_pg_card_title {
    font-size: 20px;
  }

  .impac_audience_pg_card_desc {
    font-size: 14px;
  }
}

/* ============================================================
   Desktop (≥ 1024px): hub in the middle, arrows to both sides
   ============================================================ */

@media (min-width: 1024px) {
  .impac_audience_pg_section {
    padding: 88px 48px 104px;
  }

  .impac_audience_pg_section::before {
    top: 60px;
    right: -80px;
    width: 680px;
    height: 680px;
  }

  .impac_audience_pg_underline {
    margin: 22px 0 64px;
  }

  .impac_audience_pg_map {
    grid-template-columns: minmax(0, 1fr) 96px 270px 96px minmax(0, 1fr);
    grid-template-areas:
      "stu arl hub arr pro"
      ".   .   ard .   .  "
      ".   biz biz biz .  ";
    column-gap: 0;
    align-items: center;
  }

  .impac_audience_pg_hub_wrap {
    padding: 0;
  }

  .impac_audience_pg_hub {
    width: 250px;
    height: 250px;
  }

  .impac_audience_pg_ring_one {
    inset: -16px;
  }

  .impac_audience_pg_ring_two {
    inset: -34px;
  }

  .impac_audience_pg_hub_label {
    font-size: 10.5px;
  }

  .impac_audience_pg_logo_name {
    font-size: 22px;
  }

  .impac_audience_pg_hub_text {
    font-size: 12.5px;
  }

  .impac_audience_pg_arrow_left,
  .impac_audience_pg_arrow_right {
    display: block;
    width: 100%;
    height: 2px;
  }

  .impac_audience_pg_arrow_left {
    grid-area: arl;
    background: linear-gradient(270deg, rgba(91, 80, 199, 0.15) 0%, #5b50c7 100%);
    transform-origin: right center;
  }

  .impac_audience_pg_arrow_right {
    grid-area: arr;
    background: linear-gradient(90deg, rgba(91, 80, 199, 0.15) 0%, #5b50c7 100%);
    transform-origin: left center;
  }

  .impac_audience_pg_arrow_left::after {
    content: "";
    position: absolute;
    left: -2px;
    top: -4px;
    border-right: 10px solid #5b50c7;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }

  .impac_audience_pg_arrow_right::after {
    content: "";
    position: absolute;
    right: -2px;
    top: -4px;
    border-left: 10px solid #5b50c7;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }

  .impac_audience_pg_arrow_down {
    margin: 0;
    height: 56px;
  }

  .impac_audience_pg_card {
    margin-top: 0;
    padding: 26px 26px 28px;
  }

  .impac_audience_pg_card_students {
    grid-area: stu;
  }

  .impac_audience_pg_card_professionals {
    grid-area: pro;
  }

  .impac_audience_pg_card_business {
    grid-area: biz;
    justify-self: center;
    width: 100%;
    max-width: 380px;
  }

  .impac_audience_pg_card_title {
    font-size: 21px;
  }
}

/* ============================================================
   Large desktop (≥ 1440px)
   ============================================================ */

@media (min-width: 1440px) {
  .impac_audience_pg_container {
    max-width: 1320px;
  }

  .impac_audience_pg_map {
    grid-template-columns: minmax(0, 1fr) 140px 290px 140px minmax(0, 1fr);
  }

  .impac_audience_pg_hub {
    width: 270px;
    height: 270px;
  }
}

/* ============================================================
   Keyframes
   ============================================================ */

@keyframes impac_audience_pg_fade_up {
  from {
    opacity: 0;
    transform: translateY(34px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes impac_audience_pg_zoom_in {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes impac_audience_pg_ring_out {
  from {
    opacity: 0;
    transform: scale(0.7);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes impac_audience_pg_draw_x {
  from {
    opacity: 0;
    transform: scaleX(0);
  }
  to {
    opacity: 1;
    transform: scaleX(1);
  }
}

@keyframes impac_audience_pg_draw_y {
  from {
    opacity: 0;
    transform: scaleY(0);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}

@keyframes impac_audience_pg_draw_left {
  from {
    opacity: 0;
    transform: scaleX(0);
  }
  to {
    opacity: 1;
    transform: scaleX(1);
  }
}

@keyframes impac_audience_pg_draw_right {
  from {
    opacity: 0;
    transform: scaleX(0);
  }
  to {
    opacity: 1;
    transform: scaleX(1);
  }
}

/* slow, soft pulse around the hub */
@keyframes impac_audience_pg_glow {
  0%,
  100% {
    box-shadow:
      0 30px 60px rgba(38, 16, 138, 0.38),
      inset 0 0 0 1px rgba(255, 255, 255, 0.14),
      0 0 0 0 rgba(91, 80, 199, 0.32);
  }
  50% {
    box-shadow:
      0 30px 60px rgba(38, 16, 138, 0.38),
      inset 0 0 0 1px rgba(255, 255, 255, 0.14),
      0 0 0 22px rgba(91, 80, 199, 0);
  }
}

/* ============================================================
   Reduced motion
   ============================================================ */

@media (prefers-reduced-motion: reduce) {
  .impac_audience_pg_title,
  .impac_audience_pg_underline,
  .impac_audience_pg_hub_wrap,
  .impac_audience_pg_ring,
  .impac_audience_pg_hub,
  .impac_audience_pg_arrow,
  .impac_audience_pg_card {
    opacity: 1 !important;
    animation: none !important;
    transition: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomeThreeAudience/HomeThreeAudience.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,6DAA6D;EAC7D,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2FAA2F;EAC3F,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR;;4EAE0E;EAC1E,gCAAgC;EAEhC,yFAAyF;EACzF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gCAAgC;;AAEhC;EACE,gBAAgB;EAChB,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;EAC5D,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4DAA4D;EAC5D,6BAA6B;AAC/B;;AAEA,sDAAsD;;AAEtD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA,8BAA8B;;AAE9B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,qFAAqF;EACrF;;6CAE2C;EAC3C,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qCAAqC;;AAErC;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,eAAe;EACf,6EAA6E;EAC7E,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA,gCAAgC;;AAEhC;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,gGAAgG;EAEhG,2BAA2B;EAC3B;;qCAEmC;EACnC,gBAAgB;EAChB,uGAAuG;AACzG;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,oBAAoB;EACpB,6BAA6B;EAC7B,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,mDAAmD;EACnD,oGAAoG;AACtG;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,4DAA4D;AAC9D;;AAEA;EACE;IACE,2BAA2B;IAC3B,qBAAqB;IACrB;;uCAEmC;EACrC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mCAAmC;IACnC,6DAA6D;IAC7D,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;iEAGiE;;AAEjE;;;;;EAKE,UAAU;AACZ;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,uFAAuF;AACzF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD;;;;eAIW;IACX,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oEAAoE;IACpE;;;2BAGuB;IACvB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,WAAW;EACb;;EAEA;IACE,cAAc;IACd,6EAA6E;IAC7E,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,4EAA4E;IAC5E,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gCAAgC;IAChC,iCAAiC;IACjC,oCAAoC;EACtC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,+BAA+B;IAC/B,iCAAiC;IACjC,oCAAoC;EACtC;;EAEA;IACE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sEAAsE;EACxE;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA,oCAAoC;AACpC;EACE;;IAEE;;;qCAGiC;EACnC;EACA;IACE;;;qCAGiC;EACnC;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;;;;;;;IAOE,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF","sourcesContent":["/* ============================================================\n   HomeThreeAudience — one platform, three audiences\n   Prefix: impac_audience_pg_ · no :root variables · no green\n   ============================================================ */\n\n.impac_audience_pg_section {\n  position: relative;\n  width: 100%;\n  padding: 48px 16px 60px;\n  background: linear-gradient(180deg, #f7eefa 0%, #f1e8fb 100%);\n  font-family: \"Sora\", \"Manrope\", sans-serif;\n  overflow: hidden;\n  isolation: isolate;\n}\n\n.impac_audience_pg_section *,\n.impac_audience_pg_section *::before,\n.impac_audience_pg_section *::after {\n  box-sizing: border-box;\n}\n\n/* soft glows + faint dot grid behind everything */\n.impac_audience_pg_section::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: 120px;\n  right: -180px;\n  width: 520px;\n  height: 520px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(106, 70, 240, 0.28) 0%, rgba(106, 70, 240, 0) 70%);\n  pointer-events: none;\n}\n\n.impac_audience_pg_section::after {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  inset: 0;\n  background-image:\n    radial-gradient(circle at 8% 88%, rgba(224, 168, 61, 0.2) 0%, rgba(224, 168, 61, 0) 32%),\n    radial-gradient(circle, rgba(38, 16, 138, 0.1) 1.2px, transparent 1.4px);\n  background-size: auto, 32px 32px;\n  -webkit-mask-image: linear-gradient(180deg, transparent 0%, #000 30%, #000 80%, transparent 100%);\n  mask-image: linear-gradient(180deg, transparent 0%, #000 30%, #000 80%, transparent 100%);\n  pointer-events: none;\n}\n\n.impac_audience_pg_container {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* ---------- Title ---------- */\n\n.impac_audience_pg_title {\n  max-width: 820px;\n  margin: 0;\n  font-size: clamp(24px, 4.4vw, 48px);\n  font-weight: 800;\n  line-height: 1.22;\n  letter-spacing: -0.02em;\n  color: #0f0f23;\n  text-wrap: balance;\n}\n\n.impac_audience_pg_brand {\n  background: linear-gradient(90deg, #3b1f8f 0%, #7a4cf0 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: #3b1f8f;\n}\n\n.impac_audience_pg_underline {\n  display: block;\n  width: 88px;\n  height: 4px;\n  margin: 18px 0 40px;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #5b2fd0 0%, #e0a83d 100%);\n  transform-origin: left center;\n}\n\n/* ---------- Map (mobile: single column) ---------- */\n\n.impac_audience_pg_map {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n/* ---------- Hub ---------- */\n\n.impac_audience_pg_hub_wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 26px;\n}\n\n.impac_audience_pg_ring {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 1px solid rgba(91, 80, 199, 0.28);\n  pointer-events: none;\n}\n\n.impac_audience_pg_ring_two {\n  inset: -18px;\n  border-color: rgba(91, 80, 199, 0.14);\n}\n\n.impac_audience_pg_hub {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 210px;\n  height: 210px;\n  padding: 16px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 30% 22%, #5236d6 0%, #26108a 55%, #170a5e 100%);\n  box-shadow:\n    0 30px 60px rgba(38, 16, 138, 0.38),\n    inset 0 0 0 1px rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n  text-align: center;\n}\n\n.impac_audience_pg_hub::before {\n  content: \"\";\n  position: absolute;\n  inset: 10px;\n  border-radius: 50%;\n  border: 1px dashed rgba(255, 255, 255, 0.28);\n  pointer-events: none;\n}\n\n.impac_audience_pg_hub_label {\n  padding: 3px 10px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.14);\n  font-size: 9.5px;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  color: #ffd98a;\n}\n\n.impac_audience_pg_logo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 8px 0;\n  line-height: 1.1;\n}\n\n.impac_audience_pg_logo_name {\n  margin-top: 4px;\n  font-size: 19px;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.impac_audience_pg_logo_tag {\n  margin-top: 2px;\n  font-size: 9px;\n  font-weight: 500;\n  color: #d4cffa;\n}\n\n.impac_audience_pg_hub_text {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.45;\n  color: #bfd6f5;\n}\n\n/* ---------- Connectors ---------- */\n\n.impac_audience_pg_arrow {\n  position: relative;\n  display: none;\n}\n\n.impac_audience_pg_arrow_down {\n  display: block;\n  width: 2px;\n  height: 34px;\n  margin: 0 0 6px;\n  background: linear-gradient(180deg, rgba(91, 80, 199, 0.15) 0%, #5b50c7 100%);\n  transform-origin: top center;\n}\n\n.impac_audience_pg_arrow_down::after {\n  content: \"\";\n  position: absolute;\n  left: -4px;\n  bottom: -3px;\n  border-top: 9px solid #5b50c7;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n\n/* ---------- Cards ---------- */\n\n.impac_audience_pg_card {\n  position: relative;\n  width: 100%;\n  max-width: 440px;\n  margin-top: 16px;\n  padding: 20px 20px 22px;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.9);\n  background: linear-gradient(160deg, rgba(255, 255, 255, 0.82) 0%, rgba(255, 255, 255, 0.5) 100%);\n  -webkit-backdrop-filter: blur(14px);\n  backdrop-filter: blur(14px);\n  box-shadow:\n    0 18px 40px rgba(38, 16, 138, 0.1),\n    0 2px 6px rgba(38, 16, 138, 0.05);\n  overflow: hidden;\n  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.4s ease, border-color 0.4s ease;\n}\n\n/* gradient accent line that draws across the top on hover */\n.impac_audience_pg_card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #5b2fd0 0%, #e0a83d 100%);\n  transform: scaleX(0);\n  transform-origin: left center;\n  transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.impac_audience_pg_card_head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.impac_audience_pg_card_icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  border-radius: 13px;\n  background: linear-gradient(135deg, #ece2ff 0%, #d9ccf8 100%);\n  color: #2a1a8a;\n  box-shadow: inset 0 0 0 1px rgba(91, 80, 199, 0.18);\n  transition: transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1), background 0.3s ease, color 0.3s ease;\n}\n\n.impac_audience_pg_card_title {\n  margin: 0;\n  font-size: 19px;\n  font-weight: 800;\n  line-height: 1.25;\n  color: #0f0f23;\n}\n\n.impac_audience_pg_card_desc {\n  margin: 14px 0 16px;\n  font-size: 13.5px;\n  line-height: 1.6;\n  font-weight: 500;\n  color: #34405e;\n}\n\n.impac_audience_pg_card_outcome {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0;\n}\n\n.impac_audience_pg_chip {\n  padding: 5px 12px;\n  border-radius: 999px;\n  background: #ece2ff;\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #26108a;\n}\n\n.impac_audience_pg_chip_to {\n  background: linear-gradient(100deg, #26108a 0%, #5236d6 100%);\n  color: #ffffff;\n  box-shadow: 0 8px 16px rgba(38, 16, 138, 0.25);\n}\n\n.impac_audience_pg_card_arrow {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #e0a83d;\n  font-size: 13px;\n  font-weight: 800;\n  line-height: 1;\n  color: #ffffff;\n  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@media (hover: hover) {\n  .impac_audience_pg_card:hover {\n    transform: translateY(-8px);\n    border-color: #ffffff;\n    box-shadow:\n      0 30px 56px rgba(38, 16, 138, 0.2),\n      0 2px 6px rgba(38, 16, 138, 0.06);\n  }\n\n  .impac_audience_pg_card:hover::before {\n    transform: scaleX(1);\n  }\n\n  .impac_audience_pg_card:hover .impac_audience_pg_card_icon {\n    transform: scale(1.1) rotate(-6deg);\n    background: linear-gradient(135deg, #26108a 0%, #5236d6 100%);\n    color: #ffffff;\n  }\n\n  .impac_audience_pg_card:hover .impac_audience_pg_card_arrow {\n    transform: translateX(5px);\n  }\n}\n\n/* ============================================================\n   Entrance — fade up, triggered when the section scrolls into view\n   (applies at every screen size)\n   ============================================================ */\n\n.impac_audience_pg_title,\n.impac_audience_pg_underline,\n.impac_audience_pg_hub_wrap,\n.impac_audience_pg_arrow,\n.impac_audience_pg_card {\n  opacity: 0;\n}\n\n.impac_audience_pg_visible .impac_audience_pg_title {\n  animation: impac_audience_pg_fade_up 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.1s forwards;\n}\n\n.impac_audience_pg_visible .impac_audience_pg_underline {\n  animation: impac_audience_pg_draw_x 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.35s forwards;\n}\n\n.impac_audience_pg_visible .impac_audience_pg_hub_wrap {\n  animation: impac_audience_pg_zoom_in 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.45s forwards;\n}\n\n.impac_audience_pg_visible .impac_audience_pg_ring_one {\n  animation: impac_audience_pg_ring_out 1.1s ease-out 0.8s both;\n}\n\n.impac_audience_pg_visible .impac_audience_pg_ring_two {\n  animation: impac_audience_pg_ring_out 1.3s ease-out 1s both;\n}\n\n.impac_audience_pg_visible .impac_audience_pg_hub {\n  animation: impac_audience_pg_glow 4s ease-in-out 1.8s infinite;\n}\n\n.impac_audience_pg_visible .impac_audience_pg_arrow_down {\n  animation: impac_audience_pg_draw_y 0.6s ease-out 0.95s forwards;\n}\n\n.impac_audience_pg_visible .impac_audience_pg_arrow_left {\n  animation: impac_audience_pg_draw_left 0.7s ease-out 0.95s forwards;\n}\n\n.impac_audience_pg_visible .impac_audience_pg_arrow_right {\n  animation: impac_audience_pg_draw_right 0.7s ease-out 0.95s forwards;\n}\n\n.impac_audience_pg_visible .impac_audience_pg_card_students {\n  animation: impac_audience_pg_fade_up 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.1s forwards;\n}\n\n.impac_audience_pg_visible .impac_audience_pg_card_professionals {\n  animation: impac_audience_pg_fade_up 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.3s forwards;\n}\n\n.impac_audience_pg_visible .impac_audience_pg_card_business {\n  animation: impac_audience_pg_fade_up 0.85s cubic-bezier(0.22, 1, 0.36, 1) 1.5s forwards;\n}\n\n/* ============================================================\n   Small phones (≤ 360px)\n   ============================================================ */\n\n@media (max-width: 360px) {\n  .impac_audience_pg_section {\n    padding: 40px 12px 50px;\n  }\n\n  .impac_audience_pg_hub {\n    width: 190px;\n    height: 190px;\n  }\n\n  .impac_audience_pg_hub_wrap {\n    padding: 22px;\n  }\n\n  .impac_audience_pg_card {\n    padding: 18px 16px 20px;\n  }\n\n  .impac_audience_pg_card_title {\n    font-size: 17px;\n  }\n\n  .impac_audience_pg_card_desc {\n    font-size: 13px;\n  }\n}\n\n/* ============================================================\n   Tablet (≥ 768px): two cards side by side, third centred\n   ============================================================ */\n\n@media (min-width: 768px) {\n  .impac_audience_pg_section {\n    padding: 72px 32px 84px;\n  }\n\n  .impac_audience_pg_underline {\n    margin: 20px 0 52px;\n  }\n\n  .impac_audience_pg_map {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    grid-template-areas:\n      \"hub hub\"\n      \"ard ard\"\n      \"stu pro\"\n      \"biz biz\";\n    column-gap: 22px;\n    justify-items: stretch;\n  }\n\n  .impac_audience_pg_hub_wrap {\n    grid-area: hub;\n    justify-self: center;\n    padding: 30px;\n  }\n\n  .impac_audience_pg_hub {\n    width: 230px;\n    height: 230px;\n  }\n\n  .impac_audience_pg_arrow_down {\n    grid-area: ard;\n    justify-self: center;\n    height: 44px;\n    margin-bottom: 8px;\n  }\n\n  .impac_audience_pg_card {\n    max-width: none;\n    margin-top: 18px;\n    padding: 24px 24px 26px;\n  }\n\n  .impac_audience_pg_card_students {\n    grid-area: stu;\n  }\n\n  .impac_audience_pg_card_professionals {\n    grid-area: pro;\n  }\n\n  .impac_audience_pg_card_business {\n    grid-area: biz;\n    justify-self: center;\n    width: calc(50% - 11px);\n  }\n\n  .impac_audience_pg_card_title {\n    font-size: 20px;\n  }\n\n  .impac_audience_pg_card_desc {\n    font-size: 14px;\n  }\n}\n\n/* ============================================================\n   Desktop (≥ 1024px): hub in the middle, arrows to both sides\n   ============================================================ */\n\n@media (min-width: 1024px) {\n  .impac_audience_pg_section {\n    padding: 88px 48px 104px;\n  }\n\n  .impac_audience_pg_section::before {\n    top: 60px;\n    right: -80px;\n    width: 680px;\n    height: 680px;\n  }\n\n  .impac_audience_pg_underline {\n    margin: 22px 0 64px;\n  }\n\n  .impac_audience_pg_map {\n    grid-template-columns: minmax(0, 1fr) 96px 270px 96px minmax(0, 1fr);\n    grid-template-areas:\n      \"stu arl hub arr pro\"\n      \".   .   ard .   .  \"\n      \".   biz biz biz .  \";\n    column-gap: 0;\n    align-items: center;\n  }\n\n  .impac_audience_pg_hub_wrap {\n    padding: 0;\n  }\n\n  .impac_audience_pg_hub {\n    width: 250px;\n    height: 250px;\n  }\n\n  .impac_audience_pg_ring_one {\n    inset: -16px;\n  }\n\n  .impac_audience_pg_ring_two {\n    inset: -34px;\n  }\n\n  .impac_audience_pg_hub_label {\n    font-size: 10.5px;\n  }\n\n  .impac_audience_pg_logo_name {\n    font-size: 22px;\n  }\n\n  .impac_audience_pg_hub_text {\n    font-size: 12.5px;\n  }\n\n  .impac_audience_pg_arrow_left,\n  .impac_audience_pg_arrow_right {\n    display: block;\n    width: 100%;\n    height: 2px;\n  }\n\n  .impac_audience_pg_arrow_left {\n    grid-area: arl;\n    background: linear-gradient(270deg, rgba(91, 80, 199, 0.15) 0%, #5b50c7 100%);\n    transform-origin: right center;\n  }\n\n  .impac_audience_pg_arrow_right {\n    grid-area: arr;\n    background: linear-gradient(90deg, rgba(91, 80, 199, 0.15) 0%, #5b50c7 100%);\n    transform-origin: left center;\n  }\n\n  .impac_audience_pg_arrow_left::after {\n    content: \"\";\n    position: absolute;\n    left: -2px;\n    top: -4px;\n    border-right: 10px solid #5b50c7;\n    border-top: 5px solid transparent;\n    border-bottom: 5px solid transparent;\n  }\n\n  .impac_audience_pg_arrow_right::after {\n    content: \"\";\n    position: absolute;\n    right: -2px;\n    top: -4px;\n    border-left: 10px solid #5b50c7;\n    border-top: 5px solid transparent;\n    border-bottom: 5px solid transparent;\n  }\n\n  .impac_audience_pg_arrow_down {\n    margin: 0;\n    height: 56px;\n  }\n\n  .impac_audience_pg_card {\n    margin-top: 0;\n    padding: 26px 26px 28px;\n  }\n\n  .impac_audience_pg_card_students {\n    grid-area: stu;\n  }\n\n  .impac_audience_pg_card_professionals {\n    grid-area: pro;\n  }\n\n  .impac_audience_pg_card_business {\n    grid-area: biz;\n    justify-self: center;\n    width: 100%;\n    max-width: 380px;\n  }\n\n  .impac_audience_pg_card_title {\n    font-size: 21px;\n  }\n}\n\n/* ============================================================\n   Large desktop (≥ 1440px)\n   ============================================================ */\n\n@media (min-width: 1440px) {\n  .impac_audience_pg_container {\n    max-width: 1320px;\n  }\n\n  .impac_audience_pg_map {\n    grid-template-columns: minmax(0, 1fr) 140px 290px 140px minmax(0, 1fr);\n  }\n\n  .impac_audience_pg_hub {\n    width: 270px;\n    height: 270px;\n  }\n}\n\n/* ============================================================\n   Keyframes\n   ============================================================ */\n\n@keyframes impac_audience_pg_fade_up {\n  from {\n    opacity: 0;\n    transform: translateY(34px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes impac_audience_pg_zoom_in {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes impac_audience_pg_ring_out {\n  from {\n    opacity: 0;\n    transform: scale(0.7);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes impac_audience_pg_draw_x {\n  from {\n    opacity: 0;\n    transform: scaleX(0);\n  }\n  to {\n    opacity: 1;\n    transform: scaleX(1);\n  }\n}\n\n@keyframes impac_audience_pg_draw_y {\n  from {\n    opacity: 0;\n    transform: scaleY(0);\n  }\n  to {\n    opacity: 1;\n    transform: scaleY(1);\n  }\n}\n\n@keyframes impac_audience_pg_draw_left {\n  from {\n    opacity: 0;\n    transform: scaleX(0);\n  }\n  to {\n    opacity: 1;\n    transform: scaleX(1);\n  }\n}\n\n@keyframes impac_audience_pg_draw_right {\n  from {\n    opacity: 0;\n    transform: scaleX(0);\n  }\n  to {\n    opacity: 1;\n    transform: scaleX(1);\n  }\n}\n\n/* slow, soft pulse around the hub */\n@keyframes impac_audience_pg_glow {\n  0%,\n  100% {\n    box-shadow:\n      0 30px 60px rgba(38, 16, 138, 0.38),\n      inset 0 0 0 1px rgba(255, 255, 255, 0.14),\n      0 0 0 0 rgba(91, 80, 199, 0.32);\n  }\n  50% {\n    box-shadow:\n      0 30px 60px rgba(38, 16, 138, 0.38),\n      inset 0 0 0 1px rgba(255, 255, 255, 0.14),\n      0 0 0 22px rgba(91, 80, 199, 0);\n  }\n}\n\n/* ============================================================\n   Reduced motion\n   ============================================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  .impac_audience_pg_title,\n  .impac_audience_pg_underline,\n  .impac_audience_pg_hub_wrap,\n  .impac_audience_pg_ring,\n  .impac_audience_pg_hub,\n  .impac_audience_pg_arrow,\n  .impac_audience_pg_card {\n    opacity: 1 !important;\n    animation: none !important;\n    transition: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
